import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";

export const ESTADO_BLOQUEO_AUTOGESTION = gql`
  query estadoBloqueoAutogestion($idSede: ID!, $token: String) {
    estadoBloqueoAutogestion(idSede: $idSede, token: $token) {
      idSede bloqueaMenu bloqueaCafeteria bloqueaAppCompleta mensaje
    }
  }
`;

export function useBloqueoAutogestion({ token, idSede = 1, habilitado = true }) {
  const consulta = useQuery(ESTADO_BLOQUEO_AUTOGESTION, {
    variables: { idSede: String(idSede || 1), token },
    skip: !token || !habilitado,
    fetchPolicy: "network-only", pollInterval: 30000,
    notifyOnNetworkStatusChange: true,
  });
  const { refetch } = consulta;
  useEffect(() => {
    if (!token || !habilitado) return undefined;
    const actualizar = () => { refetch().catch(() => {}); };
    window.addEventListener("focus", actualizar);
    return () => window.removeEventListener("focus", actualizar);
  }, [token, habilitado, refetch]);
  return { ...consulta, estado: consulta.data?.estadoBloqueoAutogestion };
}
